import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * Migration to default `Mapping.setClassType` to `true`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v48 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v48Projects(prevState.projects);
  }

  return nextState;
};

const v48Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, { diagram, ...project }]) => {
    const updatedDiagram = diagram.model
      ? {
          ...diagram,
          model: {
            ...diagram.model,
            linkDataArray: diagram.model.linkDataArray.map((linkData) => {
              if (isMapping(linkData)) {
                return {
                  ...linkData,
                  setClassType: true,
                };
              }
              return linkData;
            }),
          },
        }
      : diagram;

    projectsById[projectId] = {
      ...project,
      diagram: updatedDiagram,
    };
  });

  return { ...prevProjectsState, projectsById };
};
